<template>
  <Bread :breadcrumb="getBreadcrumb()" />
</template>
<script>
import Bread from "@/components/Bread.vue";
import util from "@/libs/util.js";

export default {
  name: "CourseBread",
  components: {
    Bread,
  },
  methods: {
    getBreadcrumb() {
      console.log(this.$route);

      const { getBreadConfig, bindQuery } = useCourseBreadcrumb(this.$route);
      const configFn = getBreadConfig[this.$route.name];
      console.log(configFn);

      if (!configFn) {
        return [];
      }
      const _query = bindQuery(this.$route.query);
      return configFn(_query);
    },
  },
};
function useCourseBreadcrumb(params) {
  // 根据pages和query获取面包屑List:
  // pages: 所有 [courseType, course,section, part, step]
  // query: 对象类型,包含对应字段名称
  // 返回值: [{title: '课程管理', path: '/manage/courseType'}, {title: '课程名称', path: '/manage/course'}, {title: '课节名称', path: '/manage/section'}, {title: 'part名称', path: '/manage/part'}, {title: 'step名称', path: '/manage/step'}]
  const CourseTypeOptions = [
    { value: 1, label: "体验课" },
    { value: 2, label: "正式课" },
  ];
  const PageQueryConfig = {
    courseType: {
      pageName: "课程管理",
      basicPath: "/manage/miniMady/courseType",
    },
    course: {
      pageNameFront: "typeTitle",
      pageName: "课程列表",
      basicPath: "/manage/miniMady/course",
      pathSearchKeys: ["type"],
    },
    section: {
      pageNameFront: "courseTitle",
      pageName: "课节列表",
      basicPath: "/manage/miniMady/section",
      pathSearchKeys: ["type", "courseStatus", "courseId", "courseTitle"],
    },
    part: {
      pageNameFront: "sectionName",
      pageName: "part列表",
      basicPath: "/manage/miniMady/part",
      pathSearchKeys: ["type", "courseStatus", "courseId", "courseTitle", "groupId", "sectionName", 'sectionStatus'],
    },
    step: {
      pageNameFront: "partName",
      pageName: "step列表",
      basicPath: "/manage/miniMady/step",
      pathSearchKeys: ["type", "courseStatus", "courseId", "courseTitle", "groupId", "sectionName", "sectionStatus", "partId", "partName"],
    },
  };
  function bindQuery(query) {
    if (!query.type) return query;
    const courseTypeOption = CourseTypeOptions.find(
      (item) => item.value === Number(query.type)
    );
    if (!courseTypeOption) return query;
    return {
      ...query,
      typeTitle: courseTypeOption.label,
    };
  }
  function getPath({ basicPath, pathSearchKeys }, query) {
    let path = "";
    if (basicPath) {
      path = basicPath;
    }
    if (basicPath && pathSearchKeys) {
      const _query = {};
      pathSearchKeys.forEach((key) => {
        if (query[key]) {
          _query[key] = query[key];
        }
      });
      path += util.setUrlSearch({ ..._query });
    }
    return path;
  }
  function getCourseBreadcrumbItem(config, query) {
    const { pageNameFront, pageName, basicPath, pathSearchKeys } = config;
    const item = {};
    item.title = [query[pageNameFront], pageName].filter(Boolean).join(" - ");
    const path = getPath({ basicPath, pathSearchKeys }, query);
    if (path) {
      item.path = path;
    }
    return item;
  }
  function getCourseBreadcrumb(params, appendType = "text") {
    const { pages, query } = params;
    const list = [];
    pages.forEach((page, index) => {
      if (!PageQueryConfig[page]) {
        return;
      }

      const config = PageQueryConfig[page];
      // appendType 为 文字, 去掉 path配置, 只保留title
      if (index === pages.length - 1 && appendType === "text") {
        config.basicPath = null;
        config.pathSearchKeys = null;
      }
      const item = getCourseBreadcrumbItem(config, query);

      list.push(item);
    });
    return list;
  }
  const getBreadConfig = {
    // 课程: 课程列表(正式/体验)
    ["course"]: function (query) {
      return getCourseBreadcrumb({
        query,
        pages: ["courseType", "course"],
      });
    },
    // 课程: /修改课程
    ["course-addCourse"]: function (query) {
      return [
        ...getCourseBreadcrumb(
          {
            query,
            pages: ["courseType", "course"],
          },
          "link"
        ),
        { title: query.courseId ? "编辑课程" : "添加课程" },
      ];
    },
    // 课节: 课节列表
    ["course-section"]: function (query) {
      return getCourseBreadcrumb({
        query,
        pages: ["courseType", "course", "section"],
      });
    },
    // 课节: 添加/修改课节
    ["course-addSection"]: function (query) {
      return [
        ...getCourseBreadcrumb(
          { query, pages: ["courseType", "course", "section"] },
          "link"
        ),
        { title: query.groupId ? "编辑课节" : "添加课节" },
      ];
    },
    // part: part列表
    ["course-part"]: function (query) {
      return getCourseBreadcrumb({
        query,
        pages: ["courseType", "course", "section", "part"],
      });
    },
    // part: 添加/修改part
    ["course-addPart"]: function (query) {
      return [
        ...getCourseBreadcrumb(
          { query, pages: ["courseType", "course", "section", "part"] },
          "link"
        ),
        { title: query.partId ? "编辑part" : "添加part" },
      ];
    },
    // step: step列表
    ['course-step']: function (query) {
      return getCourseBreadcrumb({
        query,
        pages: ["courseType", "course", "section", "part", "step"],
      });
    },
    // step: 添加/修改step
    ['course-addStep']: function (query) {
      return [
        ...getCourseBreadcrumb(
          { query, pages: ["courseType", "course", "section", "part", "step"] },
          "link"
        ),
        { title: query.stepId ? "编辑step" : "添加step" },
      ];
    },
  };
  return { getBreadConfig, bindQuery };
}
</script>
